import { getPurpurBorder, getPurpurColor } from '@telialt/common-theme/src/purpurSelectors';

export const CART_BOX_BORDER = `${getPurpurBorder('widthXs')} solid ${getPurpurColor('borderMedium')}`;

export const STICKY_SUMMARY_HEIGHT_CSS_VARIABLE = '--sticky-summary-height' as const;
